import ReactDOM from 'react-dom/client';
import wrapWithProviders from 'utils/wrapWithProviders';
import { BUG_WIDGET_SRC } from './bugWidgetConfig';

let bugWidgetRoot = null;

export async function bootstrapBugWidget({ store }) {
    if (!BUG_WIDGET_SRC) return;

    const mountNode = document.getElementById('overlay');
    if (!mountNode) return;

    try {
        const module = await import('./index.jsx');
        const BugWidgetMount = module.default;

        if (!bugWidgetRoot) {
            bugWidgetRoot = ReactDOM.createRoot(mountNode);
        }

        bugWidgetRoot.render(wrapWithProviders(<BugWidgetMount />, { store }));
    } catch (error) {
        console.error('[Bug Widget] Bootstrap failed:', error);
    }
}
